import { render, staticRenderFns } from "./FoclarityChatbot.vue?vue&type=template&id=35cf86cc&scoped=true&"
import script from "./FoclarityChatbot.vue?vue&type=script&lang=js&"
export * from "./FoclarityChatbot.vue?vue&type=script&lang=js&"
import style0 from "./FoclarityChatbot.vue?vue&type=style&index=0&id=35cf86cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cf86cc",
  null
  
)

export default component.exports